// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__j1X-8","OrderButton":"BuildControls_OrderButton__D7_KS","enable":"BuildControls_enable__NIvgX"};